module.exports = __webpack_public_path__ + "static/logo-rest-53f1ef2a85419ac91e01bb4e46c45403.svg";